import { render } from "./Grouping.vue?vue&type=template&id=310467fc"
import script from "./Grouping.vue?vue&type=script&lang=ts"
export * from "./Grouping.vue?vue&type=script&lang=ts"
script.render = render

export default script